module.exports = {
    request: {
        timeout: 30000,
        maxRetryError: 5,
    },
    api: {
        auth: 'https://gcp.chinhphueditor.vn/auth-api/'
    }
};